var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBalanceIncident = function SvgBalanceIncident(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7202 4.57416C17.514 2.47528 14.486 2.47528 13.2798 4.57416L2.42187 23.4676C1.21983 25.5592 2.72968 28.1684 5.14211 28.1684H26.8579C29.2703 28.1684 30.7802 25.5592 29.5781 23.4676L18.7202 4.57416ZM14.5015 16.763V12.0568C14.5015 11.1904 15.2039 10.488 16.0702 10.488C16.9366 10.488 17.639 11.1904 17.639 12.0568V16.763C17.639 17.6293 16.9366 18.3317 16.0702 18.3317C15.2039 18.3317 14.5015 17.6293 14.5015 16.763ZM14.3713 21.8054C14.3713 20.939 15.0736 20.2367 15.94 20.2367C16.8064 20.2367 17.5088 20.939 17.5088 21.8054C17.5088 22.6718 16.8064 23.3741 15.94 23.3741C15.0736 23.3741 14.3713 22.6718 14.3713 21.8054Z",
    fill: "currentColor"
  })));
};
export default SvgBalanceIncident;